const publications = [
  { label: 'All pages', value: 0 },
  { label: 'Only to the specified pages', value: 1 },
  { label: 'Excluding the pages specified', value: 2 },
] as const;

export default publications;
